import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Grid, Avatar, Button } from "@material-ui/core";
import SidebarItems from "./SidebarItems";
import { AuthContext } from "../../context/AuthContextProvider";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import SelectNegocio from "../../components/login/SelectNegocio";
import { authUtils } from "../../utils/authUtils";
import { FASTER_LARAVEL_API } from "../../api/apiService";

const useStyles = makeStyles((theme) => ({
  desktopContainer: {
    paddingTop: "5rem",
    width: "250px",
    borderRight: "1px solid #e8e8e8",
    boxShadow: "-5px 0px 12px 0px",
    backgroundColor: "white",
    minHeight: "100vh",
    position: "fixed",
    left: 0,
    top: 0,
  },

  title: {
    textAlign: "center",
    fontWeight: 600,
    // textTransform: "uppercase",
    marginBottom: "10px",
  },
  avatar: {
    width: "64px",
    height: "64px",
  },
  logout: {
    fontWeight: 800,
    marginTop: "15px",
  },
  fit: {
    // maxWidth: 'fit-content'
  },
}));

const Desktop = () => {
  const classes = useStyles();
  const { negocioActivo, logout, user, setNegocioActivo } = useContext(AuthContext);

  const changeNegocio = (negocio) => {
    setNegocioActivo(negocio);
    authUtils.saveNegocioActivo(negocio);
    window.location.reload(false);
  };

  return (
    <div className={classes.desktopContainer}>
      <Grid className={classes.fit} container direction="column" alignItems="center">
        <Typography component="span" className={classes.title} variant="h5" color="primary">
          {negocioActivo.nombre}
        </Typography>
        <Avatar className={classes.avatar} src={FASTER_LARAVEL_API + negocioActivo.imagen} />
        <Button
          className={classes.logout}
          onClick={logout}
          color="primary"
          startIcon={<ExitToAppIcon />}
        >
          SALIR
        </Button>
        {user.negocios.length > 1 && (
          <SelectNegocio
            negocioActivo={negocioActivo}
            classes={classes}
            user={user}
            onConfirmNegocio={changeNegocio}
            sidebar
          />
        )}
      </Grid>
      <SidebarItems />
    </div>
  );
};

export default Desktop;
